module.exports = __webpack_public_path__ + "img/marketingScene.1e6656c7.svg";